import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../../utils/menu";

const News = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[5].title)} menuList={menuList[5].list} titleColor="#111111" backgroundImage="/imgs/bg_news" />
      <div className="new_wrap" style={{ maxWidth: "1920px", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Outlet />
      </div>
    </>
  );
};

export default News;
